<template>
  <hr class="my-6 hr-grey" />
  <ion-row>
    <ion-col class="flex items-center justify-between">
      <ion-text class="text-md font-bold ion-text-brand"
        >Passcode</ion-text
      >
      <ion-text
        class="rounded flex items-center bg-notice-green"
        v-if="hasPinSetup"
      >
        <ion-icon
          src="/assets/general/icon-correct.svg"
          class="w-[14px] pl-2"
        ></ion-icon>
        <small class="p-1 pr-2 bold text-notice-green">Enabled</small>
      </ion-text>
      <ion-text class="rounded flex items-center bg-notice-red" v-else>
        <ion-icon
          src="/assets/general/icon-incorrect.svg"
          class="w-[14px] pl-2"
        ></ion-icon>
        <small class="p-1 pr-2 bold text-notice-red">Disabled</small>
      </ion-text>
    </ion-col>
  </ion-row>
  <ion-row>

    <ion-col>
      <ion-text class="text-[13px] ion-text-brand mt-1 block"
      >Use a 4-digit passcode to log in to your Jacaranda Finance account instead of your password.</ion-text
      >
    </ion-col>
  </ion-row>
  <div v-if="!loading">
    <div v-if="hasPinSetup">
      <button
      expand="block"
      fill="outline"
      class="button-outline button-icon button-icon-security-pin my-6"
      @click="setPin"
      data-cy="security-details-button-pin"
      >
      <span class="block capitalize text-[14px] height-[60px]">
        Update Passcode
      </span>
    </button>
    
    <button
    expand="block"
      fill="outline"
      class="button-outline"
    data-cy="security-details-button-pin"
    @click="disablePin"
    >
    <span
     class="block capitalize text-[14px] height-[60px]"
    >
    Disable Passcode


  </span>
</button>
</div>

<button
v-else
expand="block"
fill="outline"
class="button-outline button-icon button-icon-security-pin my-6"
@click="setPin"
data-cy="security-details-button-pin"
>
<span class="block capitalize text-[14px] height-[60px]">
  Set Your Passcode
</span>
</button>
</div>
<div class="mb-2">
  <toast-msg
  :isToastOpen="isToastOpen"
  :message="`Passcode has been disabled.`"
  :icon="checkmarkCircleOutline"
  />
</div>

<div class="ml-6" v-if="loading">
  <ion-spinner name="dots" color="primary"></ion-spinner>
</div>
</template>

<script setup>
import router from "@/router";
import { useSecureStorage } from "@/composables/secureStorage";
import { onMounted, ref } from "vue";
import { asyncComputed } from "@vueuse/core";
import { checkmarkCircleOutline } from "ionicons/icons";
import ToastMsg from "@/components/misc/ToastMsg.vue";
import { useMixed } from "@/composables/mixed";
const { recordSecurityEvent, securityEventKeys } = useMixed();
const { keys, getStorage, removeStorage } = useSecureStorage();
const isToastOpen = ref(false);
const otpStorage = asyncComputed(
async () => await getStorage({ key: keys.otp }),
null
);
const loading = ref(false);

const hasPinSetup = ref(false);
const setPin = () => {
  router.push({ name: "SetPIN", query: {
    "preventSkip": true,
    "skipBiometrics": true
  } });
};
const disablePin = async () => {
  try {
    loading.value = true;
    recordSecurityEvent(securityEventKeys.PasscodeDisabled)
    .catch((error) => {
      console.error("Error recording security event:", error);
    })
    .then(async () => {
      if (otpStorage.value) {
        await removeStorage({ key: keys.otp });
      }
      isToastOpen.value = true;
      hasPinSetup.value = false;
      otpStorage.value = null;
    }) 
    .finally(() => {
      loading.value = false;
    });
  } catch (e) {
    console.error("Error disabling PIN:", e);
  }
};

onMounted(async () => {
  try {
    const pin = await getStorage({ key: keys.otp });
    hasPinSetup.value = pin.value;
  } catch (e) {
    hasPinSetup.value = false;
    console.error("Error fetching PIN setup status:", e);
  }
});
</script>
